    <app-plan-limit-banner
      *ngIf="view.planLimitError"
      [error]="view.planLimitError"
      (dismissed)="view.dismissPlanLimit()">
    </app-plan-limit-banner>

    <!-- Input del mensaje -->
    <div class="chat-input" id="chat-input">
      <form [formGroup]="view.chatForm" (ngSubmit)="view.submitChat()" id="chat-form">
        <div class="chat-input-shell" id="chat-input-group">
          <!-- Textarea principal: crece con el contenido (estilo ChatGPT). Enter envía;
               Shift+Enter inserta salto de línea. -->
          <textarea #chatTextarea class="chat-input-textarea" formControlName="messageInput"
            id="chat-input-message" rows="1"
            [attr.placeholder]="view.armedGenerateSummary ? view.translate('chat.generation.armedPlaceholder') : view.translate('chat.input_placeholder')"
            aria-label="Mensaje" (input)="view.autoGrowTextarea($event.target)" (keydown)="view.onChatKeydown($event)"></textarea>
          <!-- Barra de controles DENTRO del recuadro -->
          <div class="chat-input-controls">
            <div class="chat-input-controls-left">
            <!-- Menú "+" consolidado (estilo ChatGPT): acciones, modo de búsqueda y rol experto. -->
            <div class="dropdown chat-plus">
              <button type="button" class="chat-plus-btn" id="chat-plus-btn"
                (click)="view.toggleToolsPanel()" [attr.aria-expanded]="view.showToolsPanel"
                [attr.aria-label]="view.translate('chat.plus.menuLabel') || 'Acciones'"
                [attr.title]="view.translate('chat.plus.menuLabel') || 'Acciones'">
                <i class="fas fa-plus"></i>
              </button>
              <ng-container *ngIf="view.showToolsPanel">
                <div class="chat-tools-backdrop" (click)="view.toggleToolsPanel()"></div>
                <ul class="dropdown-menu show chat-tools-dropdown" role="menu">
                  <!-- Acción principal: Generar Resumen (pide una propuesta de generación) -->
                  <li style="list-style: none;">
                    <button type="button" class="chat-tools-btn chat-tools-action dropdown-item"
                      id="chat-generate-summary-btn" (click)="view.generateSummary()">
                      <i class="fas fa-wand-magic-sparkles"></i>
                      {{ view.translate('chat.generation.generateSummary') || 'Generar Resumen' }}
                    </button>
                  </li>
                  <li class="chat-tools-divider" aria-hidden="true"></li>
                  <!-- Sección: modo de búsqueda -->
                  <li class="chat-tools-section" aria-hidden="true">{{ view.translate('chat.plus.modeSection') || 'Tipo de búsqueda' }}</li>
                  <li style="list-style: none;">
                    <button class="chat-tools-btn dropdown-item"
                      [class.active]="view.selectedInputMode === 'obtener_informacion_documento'"
                      (click)="view.selectInputMode('obtener_informacion_documento')">
                      <i class="fas fa-lightbulb"></i> {{
                      view.translate('chat.inputmode_question') || 'Obtener Información del Documento' }}
                    </button>
                  </li>
                  <li style="list-style: none;">
                    <button class="chat-tools-btn dropdown-item" [class.active]="view.selectedInputMode === 'analisis_csv'"
                      (click)="view.selectInputMode('analisis_csv')">
                      <i class="fas fa-file-csv"></i> {{ view.translate('chat.inputmode_csv') ||
                      'Consulta CSV' }}
                    </button>
                  </li>
                  <li style="list-style: none;">
                    <button class="chat-tools-btn dropdown-item"
                      [class.active]="view.selectedInputMode === 'consultar_base_datos'"
                      (click)="view.selectInputMode('consultar_base_datos')">
                      <i class="fas fa-database"></i> {{ view.translate('chat.inputmode_db') ||
                      'Consulta Base de Datos' }}
                    </button>
                  </li>
                  <li style="list-style: none;">
                    <button class="chat-tools-btn dropdown-item"
                      [class.active]="view.selectedInputMode === 'conteo_documentos'"
                      (click)="view.selectInputMode('conteo_documentos')">
                      <i class="fas fa-file-alt"></i> {{
                      view.translate('chat.inputmode_count_documents') || 'Conteo de Documentos' }}
                    </button>
                  </li>
                  <!-- Sección: rol experto "Responder como…" (solo si el plan expone roles) -->
                  <ng-container *ngIf="view.isExpertRoleSelectorVisible">
                    <li class="chat-tools-divider" aria-hidden="true"></li>
                    <li class="chat-tools-section" aria-hidden="true">{{ view.translate('chat.expertRole.label') }}</li>
                    <li style="list-style: none;">
                      <button class="chat-tools-btn dropdown-item" [class.active]="!view.selectedExpertRole"
                        [disabled]="view.expertRolesLoading"
                        (click)="view.onRoleOptionSelected(null); view.showToolsPanel = false">
                        <i class="fas fa-user"></i> {{ view.translate('chat.expertRole.placeholder') }}
                      </button>
                    </li>
                    <li style="list-style: none;" *ngFor="let role of view.expertRoles">
                      <button class="chat-tools-btn dropdown-item" [class.active]="role.code === view.selectedExpertRole"
                        [disabled]="view.expertRolesLoading" [attr.title]="role.enrichmentHint || null"
                        (click)="view.onRoleOptionSelected(role.code); view.showToolsPanel = false">
                        <i [class]="view.roleIcon(role)"></i> {{ role.displayName }}
                      </button>
                    </li>
                  </ng-container>
                </ul>
              </ng-container>
            </div>
            <!-- Chip: "Generar Resumen" armado (el próximo envío generará un resumen). -->
            <button type="button" class="generation-armed-chip" *ngIf="view.armedGenerateSummary"
              id="chat-generate-armed" (click)="view.cancelGenerateSummary()"
              [attr.aria-label]="view.translate('chat.generation.armedCancel')"
              [attr.title]="view.translate('chat.generation.armedCancel')">
              <i class="fas fa-wand-magic-sparkles" aria-hidden="true"></i>
              <span>{{ view.translate('chat.generation.generateSummary') }}</span>
              <i class="fas fa-xmark chip-x" aria-hidden="true"></i>
            </button>
            <!-- Chip: experto activo (mismo efecto visual "seleccionado" que "Generar Resumen"). -->
            <button type="button" class="generation-armed-chip expert-active-chip"
              *ngIf="view.isExpertRoleSelectorVisible && view.selectedExpertRole && view.selectedExpertRole !== 'general'"
              id="chat-expert-active" (click)="view.onRoleOptionSelected(null)"
              [attr.aria-label]="view.translate('chat.expertRole.clear')"
              [attr.title]="view.translate('chat.expertRole.clear')">
              <i [class]="view.selectedExpertRoleIcon" aria-hidden="true"></i>
              <span>{{ view.selectedExpertRoleDisplayName }}</span>
              <i class="fas fa-xmark chip-x" aria-hidden="true"></i>
            </button>
          </div>
            <!-- Controles a la derecha: enviar -->
            <div class="chat-input-controls-right">
              <button type="submit" class="chat-send-btn" [disabled]="view.chatForm.invalid || view.isLoading || view.isCurrentModeBlocked" id="chat-send-btn"
                [attr.aria-label]="view.translate('chat.input_placeholder')">
                <i class="fas fa-arrow-up"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Eco sutil del rol experto aplicado en la última respuesta (Role-Based Queries). -->
        <div class="expert-role-applied" *ngIf="view.isExpertRoleSelectorVisible && view.lastAppliedExpertRole"
          id="chat-expert-role-applied">
          <i class="fas fa-user-tie"></i>
          {{ view.translate('chat.expertRole.applied') }}: {{ view.lastAppliedExpertRole }}
        </div>
        <!-- Caso degradado: el usuario eligió rol pero el backend no lo aplicó (sin permiso/plan). -->
        <div class="expert-role-degraded"
          *ngIf="view.isExpertRoleSelectorVisible && view.isLastExpertRoleDegraded"
          id="chat-expert-role-degraded">
          <i class="fas fa-info-circle"></i>
          {{ view.translate('chat.expertRole.degraded') }}
        </div>
      </form>
    </div>
